/* src/app/main/navigation/navigation.component.scss */
ion-icon {
  color: #333333;
  cursor: pointer;
  pointer-events: none;
}
.tool {
  --background:#000;
  --padding:0;
  --border-color:#000;
}
.tag {
  background-color: #ffff00;
  font-size: 1em;
  font-weight: 800;
  padding: 5px 8px !important;
  color: #000;
  position: relative;
}
.ml-0 {
  margin-left: 0%;
}
.ml-10 {
  margin-left: 10%;
}
.ml-20 {
  margin-left: 20%;
}
.ml-30 {
  margin-left: 30%;
}
.ml-40 {
  margin-left: 40%;
}
.ml-50 {
  margin-left: 50%;
}
.ml-60 {
  margin-left: 60%;
}
.ml-70 {
  margin-left: 70%;
}
.ml-80 {
  margin-left: 80%;
}
.ml-90 {
  margin-left: 90%;
}
/*# sourceMappingURL=navigation.component.css.map */
